import { CreateCapabilityForm as Form } from './CreateCapabilityForm'
import { connect } from 'react-redux'
import { selectCapability } from '../../selectors/capabilities'
import { AppStateType } from '../../reducers'
import { selectPublishingLocations } from '../../selectors/publishingLocations'

const mapStateToProps = (state: AppStateType) => ({
  capability: selectCapability(state),
  publishingLocations: selectPublishingLocations(state),
})

export const CreateCapabilityForm = connect(mapStateToProps)(Form)
